import React, { useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import '../Register.css'
import hayatlogo from '../../assets/images/hayatlogo.jpg';
import hayatin from '../../assets/images/hayatin.jpg'
import emailicon from '../../assets/images/emailicon.jpg'
import google from '../../assets/images/google.jpg'
import facebook from '../../assets/images/facebook.jpg'
import ios from '../../assets/images/ios.jpg'
import axios from 'axios';

const Forgotpassword = () => {
    const navigate = useNavigate();
    
    // Form state
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [forgotpassword, setForgotPassword] = useState([]);
    
    // Social login state
    const [sociallogin, setSocialLogin] = useState([]);
    const [isSocialLoading, setIsSocialLoading] = useState(false);

    // Detect platform/device type
    const detectPlatform = () => {
        const userAgent = navigator.userAgent || navigator.platform || '';
        const platform = navigator.platform || '';
        
        const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
        const isMac = /Macintosh|MacIntel|MacPPC|Mac68K/.test(platform);
        const isAndroid = /Android/.test(userAgent);
        
        if (isIOS || isMac) {
            return 'ios';
        } else if (isAndroid) {
            return 'android';
        } else {
            return 'web';
        }
    };

    const [platform, setPlatform] = useState(detectPlatform());

    // Email validation
    const validateEmail = (email) => {
        if (!email.trim()) {
            return "Email is required";
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            return "Please enter a valid email address";
        }
        return "";
    };

    // Handle email input change
    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);
        // Clear error when user starts typing
        if (error) {
            setError("");
        }
    };

    // Fetch forgot password
    const fetchforgotpassword = async () => {
        // Validate email
        const emailError = validateEmail(email);
        if (emailError) {
            setError(emailError);
            return;
        }

        setIsLoading(true);
        setError("");
        const payload = {
            email: email.trim()
        };
        try {
            const response = await axios.post(`http://localhost:8000/api/website/forgot-password`, payload);
            setForgotPassword(response.data);
            
            // Navigate to reset password on success
            navigate('/reset-password');
        } catch (error) {
            console.log("Error Fetching Forgot password", error);
            let errorMessage = "Failed to send reset password email. Please try again.";
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message || error.response.data.error || errorMessage;
            }
            setError(errorMessage);
        } finally {
            setIsLoading(false);
        }
    };

    // Handle form submit
    const handleSubmit = (e) => {
        e.preventDefault();
        fetchforgotpassword();
    };

    // Handle Google Sign-In
    const handleGoogleSignIn = async () => {
        setIsSocialLoading(true);
        try {
            if (!window.google || !window.google.accounts) {
                let attempts = 0;
                while (!window.google && attempts < 50) {
                    await new Promise(resolve => setTimeout(resolve, 100));
                    attempts++;
                }
                
                if (!window.google || !window.google.accounts) {
                    alert('Google Sign-In is loading. Please wait a moment and try again.');
                    setIsSocialLoading(false);
                    return;
                }
            }

            const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
            
            if (!googleClientId) {
                alert('Google Sign-In is not configured. Please add REACT_APP_GOOGLE_CLIENT_ID to your .env file or use email/password login.');
                setIsSocialLoading(false);
                return;
            }

            const tokenClient = window.google.accounts.oauth2.initTokenClient({
                client_id: googleClientId,
                scope: 'email profile',
                callback: async (tokenResponse) => {
                    try {
                        if (tokenResponse.access_token) {
                            const userInfoResponse = await fetch('https://www.googleapis.com/oauth2/v2/userinfo', {
                                headers: {
                                    'Authorization': `Bearer ${tokenResponse.access_token}`
                                }
                            });
                            
                            if (userInfoResponse.ok) {
                                const userInfo = await userInfoResponse.json();
                                await handleSocialLogin('google', {
                                    email: userInfo.email || '',
                                    first_name: userInfo.given_name || userInfo.name || '',
                                });
                            } else {
                                throw new Error('Failed to fetch user info from Google');
                            }
                        } else {
                            setIsSocialLoading(false);
                        }
                    } catch (error) {
                        console.error('Google Sign-In error:', error);
                        alert('Failed to sign in with Google. Please try again.');
                        setIsSocialLoading(false);
                    }
                },
            });

            tokenClient.requestAccessToken({ prompt: 'consent' });

        } catch (error) {
            console.error('Error initializing Google Sign-In:', error);
            alert('Failed to initialize Google Sign-In. Please try again.');
            setIsSocialLoading(false);
        }
    };

    // Handle Apple Sign-In
    const handleAppleSignIn = async () => {
        setIsSocialLoading(true);
        try {
            if (window.AppleID && window.AppleID.auth) {
                window.AppleID.auth.init({
                    clientId: process.env.REACT_APP_APPLE_CLIENT_ID || '',
                    scope: 'name email',
                    redirectURI: window.location.origin,
                    usePopup: true
                });

                const response = await window.AppleID.auth.signIn();
                
                if (response.authorization) {
                    await handleSocialLogin('apple', {
                        email: response.user?.email || '',
                        first_name: response.user?.name?.firstName || '',
                    });
                }
            } else {
                alert('Apple Sign-In is being configured. Please use email/password for now.');
            }
        } catch (error) {
            console.error('Error with Apple Sign-In:', error);
            alert('Failed to sign in with Apple. Please try again.');
        } finally {
            setIsSocialLoading(false);
        }
    };

    // Handle Facebook Sign-In
    const handleFacebookSignIn = async () => {
        setIsSocialLoading(true);
        try {
            if (window.FB) {
                window.FB.login(async (response) => {
                    if (response.authResponse) {
                        window.FB.api('/me', { fields: 'name,email,first_name' }, async (userInfo) => {
                            await handleSocialLogin('facebook', {
                                email: userInfo.email || '',
                                first_name: userInfo.first_name || userInfo.name || '',
                            });
                        });
                    } else {
                        alert('Facebook login was cancelled or failed.');
                    }
                }, { scope: 'email,public_profile' });
            } else {
                alert('Facebook Sign-In is being configured. Please use email/password for now.');
            }
        } catch (error) {
            console.error('Error with Facebook Sign-In:', error);
            alert('Failed to sign in with Facebook. Please try again.');
        } finally {
            setIsSocialLoading(false);
        }
    };

    // Common social login handler
    const handleSocialLogin = async (provider, userData) => {
        try {
            const payload = {
                email: userData.email,
                first_name: userData.first_name || '',
                device_type: platform,
            };

            const response = await axios.post(`http://localhost:8000/api/website/social-login`, payload);
            console.log("Social Login Response:", response.data);
            setSocialLogin(response.data);
            
            if (response.data) {
                if (response.data.user_id) {
                    localStorage.setItem('user_id', response.data.user_id);
                }
                if (response.data.token) {
                    localStorage.setItem('token', response.data.token);
                }
                if (response.data.user) {
                    localStorage.setItem('user', JSON.stringify(response.data.user));
                }
            }
            
            navigate("/");
        } catch (error) {
            console.log("Error Fetching the Social Login Data:", error);
            
            let errorMessage = "Social login failed. Please try again.";
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message || error.response.data.error || errorMessage;
            }
            alert(errorMessage);
        } finally {
            setIsSocialLoading(false);
        }
    };

    // Handle social icon click based on platform
    const handleSocialIconClick = (iconType) => {
        if (isSocialLoading) return;
        
        if (iconType === 'google') {
            handleGoogleSignIn();
        } else if (iconType === 'apple' || iconType === 'ios') {
            handleAppleSignIn();
        } else if (iconType === 'facebook') {
            handleFacebookSignIn();
        }
    };

    // Load Google Identity Services script
    React.useEffect(() => {
        if (!window.google) {
            const script = document.createElement('script');
            script.src = 'https://accounts.google.com/gsi/client';
            script.async = true;
            script.defer = true;
            script.onload = () => {
                console.log('Google Identity Services loaded');
            };
            script.onerror = () => {
                console.error('Failed to load Google Identity Services');
            };
            document.body.appendChild(script);
        }
    }, []);
    return (
        <div className="register-container">
            <div className="register-left">
                <img src={hayatlogo} alt="Register" />
            </div>

            <div className='register-right'>
                <div className='rightside-header'>
                    <img src={hayatin} alt='hayatin' />
                    <div className='signin-account'>
                        <p>Remember Your Password</p>
                        <Link to="/login" className="signin-link">
                            Sign In
                        </Link>
                    </div>
                </div>

                <div className='center-banner'>
                    <div className='register-heading'>
                        <h4>Reset Your Password</h4>
                    </div>

                    <div className='form-container'>

                        <form onSubmit={handleSubmit}>
                            <div className="input-group">
                                <h6>Email <span>*</span></h6>
                                <div className='input-field'>
                                    <img src={emailicon} alt='emailicon' className="input-icon" />
                                    <input 
                                        type="email" 
                                        value={email}
                                        onChange={handleEmailChange}
                                        placeholder="Enter Your Email" 
                                        required 
                                    />
                                </div>
                                {error && <span style={{ color: 'red', fontSize: '12px', marginTop: '5px', display: 'block' }}>{error}</span>}
                            </div>

                            <div className='createaccount-button'>
                                <button 
                                    type="submit" 
                                    className="create-account-btn" 
                                    disabled={isLoading}
                                >
                                    {isLoading ? "Verifying..." : "Verify"}
                                </button>
                            </div>

                        </form>
                        <div className="divider">
                            <hr /><p>Continue With</p><hr />
                        </div>
                        <div className='socialicon'>
                            <img 
                                src={google} 
                                alt='google' 
                                onClick={() => {
                                    if (platform === 'android' || platform === 'web') {
                                        handleSocialIconClick('google');
                                    } else {
                                        alert('Google Sign-In is available on Android and Web. Please use Apple Sign-In or email/password.');
                                    }
                                }}
                                style={{ cursor: 'pointer' }}
                                title="Sign in with Google (Android/Web)"
                            />
                            <img 
                                src={facebook} 
                                alt='facebook' 
                                onClick={() => handleSocialIconClick('facebook')}
                                style={{ cursor: 'pointer' }}
                                title="Sign in with Facebook"
                            />
                            <img 
                                src={ios} 
                                alt='apple' 
                                onClick={() => {
                                    if (platform === 'ios') {
                                        handleSocialIconClick('apple');
                                    } else {
                                        alert('Apple Sign-In is available on iOS and Mac. Please use Google Sign-In or email/password.');
                                    }
                                }}
                                style={{ cursor: 'pointer' }}
                                title="Sign in with Apple (iOS/Mac)"
                            />
                        </div>
                        {isSocialLoading && (
                            <div style={{ textAlign: 'center', marginTop: '10px', color: '#666' }}>
                                Signing in...
                            </div>
                        )}
                    </div>
                </div>
            </div>

        </div>
    );
}


export default Forgotpassword